export const TREATMENT_HEADER_HEIGHT = 140;
export const TREATMENT_PHOTO_WIDTH = 340;
export const CANVAS_EXPORT_MULTIPLIER = 3;
export const CANVAS_EXPORT_FORMAT = 'png';
